import { PayloadAction } from '@reduxjs/toolkit';

import { SavedState, UndoRedoState } from 'editor/src/store/editorModules/undoRedo/types';

const pushNextStateReducer = (state: UndoRedoState, action: PayloadAction<SavedState>) => {
  state.next.push(action.payload);
};

export default pushNextStateReducer;
